[
  {
    "code": "RW-02",
    "name": "Est"
  },
  {
    "code": "RW-03",
    "name": "Nord"
  },
  {
    "code": "RW-04",
    "name": "Ouest"
  },
  {
    "code": "RW-05",
    "name": "Sud"
  },
  {
    "code": "RW-01",
    "name": "Ville de Kigali"
  }
]